(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivo-potential-points"] && !Shopify.designMode) return;
  try {
    var noPointsText = document.querySelector('.rivo-container-points').getAttribute('data-no-points-text');

function getUSDValue(localValue) {
  if (window.Shopify && window.Shopify.currency) {
    var rate = window.Shopify.currency.rate;
    var normalized = localValue.replace(',', '.').replace(/[^0-9.]/g, '');
    var numericValue = Number(normalized);
    return numericValue / rate;
  }
  return Number(localValue.replace(',', '.').replace(/[^0-9.]/g, ''));
}

function updatePotentialPoints(dataValue) {
  var balanceAmount = Number(document.querySelector('.rivo-container-points').getAttribute('data-balance-amount')) || 1;
  var usdValue = getUSDValue(dataValue);
  var roundedValue = Math.ceil(usdValue);
  var points = roundedValue * balanceAmount;
  var pointsSpan = document.getElementById('rivo-points-value');
  if (isNaN(points) || !isFinite(points) || points === 0) {
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = 'none';
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    var container = document.querySelector('.rivo-potential-text');
    if (container) {
      var p = document.createElement('p');
      p.className = 'rivo-sentence';
      p.textContent = noPointsText || '';
      container.appendChild(p);
    }
  } else {
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = '';
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    if (pointsSpan) pointsSpan.textContent = points;
  }
  var potentialText = document.querySelector('.rivo-container-points');
  if (potentialText) potentialText.style.display = '';
  return points;
}

// Only run on DOMContentLoaded, no click listeners
document.addEventListener('DOMContentLoaded', function() {
  // Initial update
  var loyaltyInput = document.querySelector('input[name="loyalty-value"]');
  if (loyaltyInput) {
    var defaultValue = loyaltyInput.value;
    updatePotentialPoints(defaultValue);
  }

  // Listen for clicks on inputs with name="id"
  document.querySelectorAll('input[name="id"]').forEach(function(input) {
    
    input.addEventListener('click', function() {
      // Find the closest parent with class block-swatch__item-group
      var parentGroup = input.closest('.block-swatch__item-wrap');
      if (parentGroup) {
        // Find the loyalty input by name within this group
        
        var groupLoyaltyInput = parentGroup.querySelector('input[name="loyalty-value"]');
        if (groupLoyaltyInput) {
          updatePotentialPoints(groupLoyaltyInput.value);
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
